import { get, merge, reduce, set, find } from 'lodash';
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { validateFormField } from '../../../../../../modelValidator';
import * as contactApi from '../../../../../../redux/actionCreators/async/contacts';
import * as contactStore from '../../../../../../redux/actionCreators/sync/contacts';
import TextField from '../../../../../../common/components/c_TextField';
import TextArea from '../../../../../../common/components/c_TextArea';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import CheckList from '../../../../../../common/components/c_CheckList';
import Button from '../../../../../../common/components/Button';

import { referralsByRole } from '../../../../../../lib/staticData';
import * as ui from '../../../../../../redux/actionCreators/sync/ui';

const message = 'This field is required.';
const required = { message };

function ProfilePanelForm(props) {
  const {
    profile,
    contactTypes,
    foundUsViaList,
    onChange,
    onSave,
    saveDisabled,
    labels
  } = props;

  function handleChange(field) {
    return (event, value, primaryText) => {
      onChange && onChange(event, field, value);
      // primaryText && onSave && onSave(event);
    }
  }

  function handleSave() {
    (onSave) ? onSave(event) : null;
  }

  const otherfoundUsVia = get(find(foundUsViaList, {name: 'Other, Please Specify:'}), 'id');

  return (
    <div className='contact-worksheet-profile'>
       <div className='grid grid-worksheet-profile'>
        <div className='row'>
          <div className='col'>
              <TextField
                value={get(profile, 'title.value')}
                floatingLabelText={"Contact Title"}
                errorText={get(profile, 'title.errors[0]')}
                onChange={handleChange('title')}
                data-id='title'
              />

          </div>

          <div className='col'>
            <TextField
              value={get(profile, 'department.value')}
              floatingLabelText={"Department"}
              errorText={get(profile, 'department.errors[0]')}
              onChange={handleChange('department')}
              data-id='department'
            />

          </div>
         </div>
         <div className='row'>
         <div className='col'>
           <CheckList
              value={get(profile, 'types.value')}
              floatingLabelText={"Contact Type"}
              errorText={get(profile, 'types.errors[0]')}
              onBlur={handleChange('types')}
              menuItems={contactTypes}
              data-id='type'
            />

         </div>
         <div className='col'>
           <DropDownMenu
                className='profile-foundusvia'
                value={get(profile, 'foundUsVia.value')}
                floatingLabelText={labels.foundUsVia}
                errorText={get(profile, 'foundUsVia.errors[0]')}
                onChange={handleChange('foundUsVia')}
                menuItems={foundUsViaList}
                data-id='foundUsVia'
              />

          </div>
        </div>
        <div className='row'>
          <div className='col'>
          {
           get(profile, 'foundUsVia.value') === otherfoundUsVia && <TextField
                floatingLabelText='Please Specify'
                value={get(profile, 'foundUsOther.value')}
                errorText={get(profile, 'foundUsOther.errors[0]')}
                onChange={handleChange('foundUsOther')}
                data-id='foundUsOther'
            />
          }
          </div>
          <div className='col'></div>
        </div>
      </div>
      <label className='textarea-label'>Initial Inquiry Reason</label>
      <TextArea
        value={get(profile, 'initialInquiry.value')}
        errorText={get(profile, 'initialInquiry.errors[0]')}
        onChange={handleChange('initialInquiry')}
        data-id={'initial-inquiry'}
      />
      <label className='textarea-label'>Initial Sales Notes</label>
      <TextArea
        value={get(profile, 'salesNotes.value')}
        errorText={get(profile, 'salesNotes.errors[0]')}
        onChange={handleChange('salesNotes')}
        data-id={'initial-sales'}
      />
      <label className='textarea-label'>General Comments</label>
      <TextArea
        value={get(profile, 'generalComments.value')}
        errorText={get(profile, 'generalComments.errors[0]')}
        onChange={handleChange('generalComments')}
        data-id={'general-comments'}
      />
      <Button
        disabled={saveDisabled}
        className={'button-main-large'}
        data-id={'Save'}
        label={'Save'}
        onClick={handleSave}
      />
    </div>
  );
}

@connect((store) => {
  const contact = get(store.admin, 'contactInContactWorksheet', {});
  const {
    foundUsViaList,
    contactTypes
  } = store.staticData;

  return {
    foundUsViaList: referralsByRole(foundUsViaList, 'C'),
    contactTypes,
    contact,
    labels: get(store, 'labels.WorksheetProfilePanel', {})
  };
})
export default class ProfilePanel extends React.Component {
  static propTypes = {
    foundUsViaList : PropTypes.array.isRequired,
    contact : PropTypes.shape({
      profile : PropTypes.object.isRequired,
      user : PropTypes.object,
      company : PropTypes.object
    }).isRequired,
    labels: PropTypes.object
  }

  constructor(props, context) {
    super(props, context);

    const {
      profile = {}
    } = props.contact || {};

    const currentState = () => this.state;

    this.state = {
      title : {
        value : profile.title,
        required
      },
      department : {
        value : profile.department,
        required
      },
      types : {
        value : profile.types,
        required
      },
      foundUsVia : {
        value : profile.foundUsVia,
        required
      },
      foundUsOther : {
        value : profile.foundUsOther,
        custom : {
          func: (val) => get(currentState(), 'foundUsVia.value', 0) !== 55 || val,
          message
        }
      },
      initialInquiry : {
        value : profile.initialInquiry
      },
      salesNotes : {
        value: profile.salesNotes
      },
      generalComments : {
        value: profile.generalComments
      },
      saveDisabled: true
    };
  }

  handleUpdateField = (event, field, value) => {
    const newState = set(merge({}, this.state), `${field}.value`, value || event.target.value);
    set(newState, 'saveDisabled', false);
    set(newState, `${field}.errors`, validateFormField(field, newState));
    this.setState(newState);
  }

  handleSubmitForm = (event) => {
    const profile = reduce(this.state, (obj, prop, key) => {
      obj[key] = (prop) ? prop.value : undefined;
      return obj;
    }, { id: this.props.contact.profile.id });
    const user = { id: this.props.contact.user.id };
    const company = { id: this.props.contact.company.id };

    this.props.dispatch(contactApi.updateContact({profile, user, company}, (err, data) => {
      if (err) {
        return console.error(err);
      } else {
        this.props.dispatch(ui.showSnackBar('Your work has been saved'));
      }

      // refresh contact
      this.props.dispatch(contactApi.getContact(profile.id, (err, data) => {
        if (err || !data) {
          return console.error(err || 'Fetch failed.');
        }
        this.props.dispatch(contactStore.updateContactInContactWorksheet(data));
      }));
    }));
    this.setState({saveDisabled: true});
  }

  render() {

    return (
      <ProfilePanelForm
        saveDisabled={this.state.saveDisabled}
        profile={this.state}
        foundUsViaList={this.props.foundUsViaList}
        contactTypes={this.props.contactTypes}
        onChange={this.handleUpdateField}
        onSave={this.handleSubmitForm}
        labels={this.props.labels}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Contact/Worksheet/Content/Profile/index.js